<template lang="pug">
  v-dialog(
    id="cart"
    v-model="show"
    content-class="item-dialog"
    scrollable
    tile
    max-width="800px"
  )
    template(v-if="cart.merchant_id == ''")
      v-card
        v-card-title
          h3.header-title Your Cart Orders
          v-spacer
          v-btn(
            class="close-button"
            x-small
            color="red"
            @click="close"
          )
            v-icon mdi-close-box
        v-card-text
          b Your cart is empty.
    template(v-else-if="details")
      v-card
        v-card-title
          h3.header-title Your Cart Orders
          v-spacer
          v-btn(
            class="close-button"
            x-small
            color="red"
            @click="close"
          )
            v-icon mdi-close-box
        v-card-subtitle.my-2
          v-icon(
            color="primary"
          ) mdi-store
          b.ml-1 {{ details.merchant_name }}
          v-icon(
            color="primary"
          ) mdi-arrow-right-bold
          span.ml-1 {{ details.store_name }}
          v-icon(
            color="primary"
          ) mdi-arrow-right-bold
          v-icon(
            color="primary"
          ) mdi-chair-school
          span.ml-1 {{ details.table_name }}
        v-list(
          class="p-0"
          three-line
          flat
        )
          v-list-item-group
            template(
              v-for="(i, index) in cart.order_list"
            )
              v-list-item(
                :key="i.item_id"
                :ripple="false"
              )
                template
                  v-list-item-action(
                    class="m-auto"
                    style="max-width: 30%;"
                  )
                    v-text-field(
                      v-model="i.item_quantity" 
                      append-outer-icon="mdi-plus" 
                      @click:append-outer="add(i)" 
                      prepend-icon="mdi-minus" 
                      @click:prepend="minus(i)"
                    )
                    //- b X {{ i.item_quantity }}
                  v-list-item-content(
                    class="ml-2 p-0"
                  )
                    v-list-item-title
                      b {{ i.item_name }}
                    v-list-item-subtitle(
                      v-if="i.item_variant"
                    ) {{ i.item_variant.variant_name }}
                    v-list-item-subtitle(
                      v-if="i.item_addon.length"
                      v-for="(a, idx) in i.item_addon"
                      :key="a.addon_id"
                    )
                      em - {{ a.addon_name }}
                    v-list-item-subtitle(v-if="i.item_remarks") * {{ i.item_remarks }}
                  v-list-item-action(
                    class="m-auto"
                  )
                    span RM {{ calculatePrice(i) }}
                  v-list-item-action(
                    class="ml-4 m-auto"
                  )
                    v-btn(
                      color="red"
                      x-small
                      @click="deleteItem(index)"
                    )
                      v-icon mdi-delete
              v-divider(
                class="m-0"
                v-if="index < cart.order_list.length - 1"
                :key="index"
              )
        v-card-actions.pt-0.pb-4
          v-btn(
            tile
            class="m-auto"
            color="red lighten-1"
            @click="clearCart"
          )
            v-icon(center) mdi-delete
            span Clear Cart
        CartDetails(
          :decrypted="decrypted"
          :details="details"
          :oriPrice="oriPrice"
          :salePrice="salePrice"
          :minPrice="parseFloat(merchantConstraints.dinein_minimum)"
          :extraPrice="parseFloat(merchantConstraints.dinein_extra)"
          :reservePax="merchantConstraints.reserve_pax"
        )
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import CartDetails from "@/views/dinein/CartDetails";

export default {
  props: { decrypted: Object, details: Object, dialog: Boolean },
  components: {
    CartDetails
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    show: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("close");
      }
    },
    cart() {
      return this.$store.getters.dinein;
    },
    oriPrice() {
      return this.cart.order_list.reduce((acc, x) => {
        return acc + parseFloat(this.calculateOriPrice(x));
      }, 0);
    },
    salePrice() {
      return this.cart.order_list.reduce((acc, x) => {
        return acc + parseFloat(this.calculatePrice(x));
      }, 0);
    },
    merchantConstraints() {
      return this.$store.getters.merchantConstraints;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    minus(i) {
      if (i.item_quantity > 1) i.item_quantity -= 1;
    },
    add(i) {
      if (i.item_quantity < i.item_stock) i.item_quantity += 1;
    },
    deleteItem(i) {
      this.$store.commit("customer/removeFromDineIn", i);
    },
    calculateOriPrice(i) {
      var total = 0;

      //normal item price
      total += parseFloat(i.item_price);

      if (i.item_variant)
        //variant price
        total += parseFloat(i.item_variant.variant_price);

      if (i.item_addon.length)
        //addon price
        i.item_addon.forEach(a => {
          total += parseFloat(a.addon_price);
        });

      /*
      var originalPrice = (total * i.item_quantity);

      if (this.orderType === 1 && originalPrice < this.merchantConstraints[0].dinein_minimum) {
        return (originalPrice + this.merchantConstraints[0].dinein_extra).toFixed(2);
      } 
      else if (this.orderType === 2 && originalPrice < this.merchantConstraints[0].reserve_minimum) {
        return (originalPrice + this.merchantConstraints[0].reserve_extra).toFixed(2);
      }
      else if (this.orderType === 3 && originalPrice < this.merchantConstraints[0].pickup_minimum) {
        return (originalPrice + this.merchantConstraints[0].pickup_extra).toFixed(2);
      }
      else if (this.orderType === 4 && originalPrice < this.merchantConstraints[0].delivery_minimum) {
        return (originalPrice + this.merchantConstraints[0].delivery_extra).toFixed(2);
      }
      else {
        return originalPrice.toFixed(2);
      }
      */

      return (total * i.item_quantity).toFixed(2);
    },
    calculatePrice(i) {
      var total = 0;

      //normal item price
      total +=
        parseFloat(i.item_saleprice) != 0
          ? parseFloat(i.item_saleprice)
          : parseFloat(i.item_price);

      if (i.item_variant)
        //variant price
        total +=
          parseFloat(i.item_variant.variant_saleprice) != 0
            ? parseFloat(i.item_variant.variant_saleprice)
            : parseFloat(i.item_variant.variant_price);

      if (i.item_addon.length)
        //addon price
        i.item_addon.forEach(a => {
          total +=
            parseFloat(a.addon_saleprice) != 0
              ? parseFloat(a.addon_saleprice)
              : parseFloat(a.addon_price);
        });

      return (total * i.item_quantity).toFixed(2);
    },
    clearCart() {
      this.$store.commit("customer/clearDineIn");
    }
    // Used when being redeeming assigned promotions from merchants. Params are defined from PromotionsMerchants.vue (DEPRECATED with the use of dialog box written directly
    //  in DineIn.vue, Reservation.vue, Pickup.vue, and Delivery.vue)
    /*
    redirectToOrderTypePage() {
      let promoCodeFromRedirect = this.$route.params.promoCode;
      let orderTypeFromRedirect = this.$route.params.orderType;

      typeof promoCodeFromRedirect !== "undefined" && typeof orderTypeFromRedirect !== "undefined" ? this.orderType = parseInt(orderTypeFromRedirect) : "";
    }
    */
  }
};
</script>
